import * as React from 'react';

import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { HeroBanner } from '../../components/HeroBanner';

export function HeroBannerContainer() {
  const subdomain = useSelector((state: IApplicationState) => state.subdomain);

  return <HeroBanner subdomain={subdomain} />;
}
